import { render } from "./ProductTilesContainer.vue?vue&type=template&id=1e06440c&scoped=true"
import script from "./ProductTilesContainer.vue?vue&type=script&lang=js"
export * from "./ProductTilesContainer.vue?vue&type=script&lang=js"

import "./ProductTilesContainer.vue?vue&type=style&index=0&id=1e06440c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e06440c"]])

export default __exports__